<template>
    <div
        v-b-tooltip.hover.left.html="getConversationName()"
        class="chat-button-wrapper"
        :class="{ 'grow-bubble-ani': locationIndex === 0 }"
        :style="{ bottom: getBottomOffset() + 'px' }"
        :id="conversation.id"
    >
        <div v-if="hasUnread" class="unread-indicator"></div>
        <div
            class="chat-button"
            :style="{ backgroundColor: stringToColor(conversation.id) }"
            @click="conversationClick"
        >
            <div
                v-if="getAvatar()"
                :style="{
                    backgroundImage: 'url(\'' + getAvatar() + '/small.jpg\')',
                }"
                class="avatar"
            ></div>
            <div v-else style="display:flex;align-items:center;">
                <BaseIcon class="icon" name="user" />
            </div>
        </div>
        <div class="close-btn" @click="conversationCloseClick">
            <BaseIcon name="times" />
        </div>
    </div>
</template>

<script>
import stringToColor from '~/utils/stringToColor';
export default {
    name: 'ChatButton',
    props: {
        locationIndex: Number,
        conversation: {},
        hasUnread: Boolean,
    },
    data() {
        return {
            spacing: 5,
            itemHeight: 60,
            baseOffset: 80 + 85,
        };
    },
    methods: {
        stringToColor(str) {
            return stringToColor(str);
        },
        getBottomOffset() {
            return (
                (this.itemHeight + this.spacing) * this.locationIndex +
                this.baseOffset +
                this.spacing
            );
        },
        getAvatar() {
            let { conversation } = this;
            return conversation && conversation.participants && conversation.participants.length
                ? conversation.participants[0].avatar
                : null;
        },
        getConversationName() {
            let { conversation } = this;

            let participantName =
                conversation && conversation.participants && conversation.participants.length
                    ? conversation.participants[0].displayName
                    : 'Unknown';
            let participantTitle =
                conversation &&
                conversation.participants &&
                conversation.participants.length &&
                conversation.participants[0].title
                    ? '<strong>' + conversation.participants[0].title + '</strong>'
                    : '';

            return {
                title:
                    "<div style='text-align: center'>" +
                    participantName +
                    '<br />' +
                    participantTitle +
                    '</div>',
            };
        },
        conversationClick() {
            this.$interfaces.communication.chat.conversation.id(this.conversation.id).put({
                body: {
                    open: true,
                },
            });
            this.$emit('conversation-click', this.conversation.id);
        },
        conversationCloseClick() {
            this.$emit('conversation-remove', this.conversation.id);
        },
    },
};
</script>

<style scoped>
.icon {
    font-size: 30px;
    color: white;
}
.chat-button-wrapper {
    display: flex;
    justify-content: center;
    height: 60px;
    width: 60px;
    position: fixed;
    right: 20px;
}
.chat-button {
    width: 100%;
    height: 100%;
    font-size: 100%;
    border-radius: 50%;
    box-shadow: var(--shadow);
    overflow: hidden;
    /*background-color: var(--primary);*/
    cursor: pointer;
    display: flex;
    justify-content: center;
}
.chat-button:hover {
    opacity: 0.9;
    transition: opacity 0.1s;
}
.close-btn {
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid rgb(100, 100, 100);
    border-radius: 50%;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 13px;
    background-color: rgb(200, 200, 200);
    cursor: pointer;
}
.close-btn:hover {
    background-color: rgb(180, 180, 180);
    transition: background-color 0.1s;
}
.avatar {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.avatar-letter {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    height: 100%;
    width: 100%;
}
.unread-indicator {
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid black;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    align-items: center;
    text-align: center;
    font-size: 13px;
    background-color: red;
    cursor: pointer;
    z-index: 1;
}
.grow-bubble-ani {
    animation: growBubble 0.25s;
}
@keyframes growBubble {
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }
}
</style>
